module.exports = "/_next/static/images/powerGlobe-f9b519a545f393d91359a29258ffcb23.png.webp";